import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators"
import store from 'Store/index';

@Module({ dynamic: true, store, name: 'dcstore', namespaced: true })
export class DownloadUrlStore extends VuexModule {
    private downloadUrl: string;
    private pageId: string;
    private paragraphId: string;
    private documentName: string;

    public get getDownloadUrl(): string {
        return this.downloadUrl;
    }

    @Mutation
    public setDownloadUrl(s: string) {
        this.downloadUrl = s;
    }

    public get getPageId(): string {
        return this.pageId;
    }

    @Mutation
    public setPageId(s: string) {
        this.pageId = s;
    }

    public get getParagraphId(): string {
        return this.paragraphId;
    }

    @Mutation
    public setParagraphId(s: string) {
        this.paragraphId = s;
    }

    public get getDocumentName(): string {
        return this.documentName;
    }

    @Mutation
    public setDocumentName(s: string) {
        this.documentName = s;
    }
}
export default getModule(DownloadUrlStore);